module.exports = __webpack_public_path__ + "img/about-listed (3).0d3ceff9.jpg";